import React from "react";
import { STREETEASY_SITE_CONTENT_SELECTOR } from "@streeteasy/design-system/constants/streeteasySiteContentSelector";
import { string } from "prop-types";

import DrawerModal from "../../../../shared/components/DrawerModal";
import ErrorMessage from "../../../../shared/components/ErrorMessage";
import InquirySuccess from "../../../../shared/components/InquirySuccess";
import MODAL_VIEW_TYPES from "../../constants/modalViewTypes";
import { useAgentData } from "../../redux/hooks/agentHooks";
import { useContactFormData } from "../../redux/hooks/contactFormHooks";
import { useUIBehavior, useUIData } from "../../redux/hooks/uiHooks";
import ListingAgentContactForm from "../ListingAgentContactForm";
import * as S from "./styled";

const ListingAgentContactDrawer = ({
  email,
  name,
  phoneNumber,
  rootElementId
}) => {
  const { isAgentContactDrawerOpen, modalViewType } = useUIData();
  const {
    agentImageSrc,
    agentName,
    agentTitle,
    brokerage,
    isPro
  } = useAgentData();
  const { closeAgentContactDrawer, openHostModal } = useUIBehavior();
  const { propertyAddress } = useContactFormData();

  const ariaLabelledBy = "listing_agent_contact_drawer_label";
  const ariaDescribedBy = "listing_agent_contact_drawer_description";

  const views = {
    [MODAL_VIEW_TYPES.agentContact]: (
      <S.FormContent>
        <S.Title id={ariaLabelledBy}>Contact Listing Agent</S.Title>
        <S.ListingAgentDescription
          agentImageSrc={agentImageSrc}
          agentName={agentName}
          agentTitle={agentTitle}
          brokerage={brokerage}
          descriptionTextId={ariaDescribedBy}
          handleContactBuyersAgentClick={openHostModal}
          isPro={isPro}
        />
        <ListingAgentContactForm
          handleCancelClick={closeAgentContactDrawer}
          initialFormValues={{
            email: email || "",
            message: `I'm interested in ${propertyAddress}.`,
            name: name || "",
            phone: phoneNumber || ""
          }}
        />
      </S.FormContent>
    ),
    [MODAL_VIEW_TYPES.error]: (
      <S.MessageContainer>
        <ErrorMessage>
          Sorry, something went wrong.
          <br />
          Please try again later.
        </ErrorMessage>
      </S.MessageContainer>
    ),
    [MODAL_VIEW_TYPES.success]: (
      <S.MessageContainer>
        <InquirySuccess
          ariaContentDescribedBy={ariaDescribedBy}
          ariaContentLabelledBy={ariaLabelledBy}
          titleText="Message Sent!"
        >
          An agent will reach out to you shortly.
        </InquirySuccess>
      </S.MessageContainer>
    )
  };

  return (
    <>
      <S.ModalPortalGlobalStyle />
      <DrawerModal
        aria={{
          describedby: ariaDescribedBy,
          labelledby: ariaLabelledBy
        }}
        handleOnClose={closeAgentContactDrawer}
        isOpen={isAgentContactDrawerOpen}
        portalClassName={S.ModalPortalClassName}
        render={() => (
          <S.ModalContent data-qa="listing-agent-contact-drawer">
            <S.XButton onClick={closeAgentContactDrawer} />
            {views[modalViewType]}
          </S.ModalContent>
        )}
        rootElementId={rootElementId}
      />
    </>
  );
};

ListingAgentContactDrawer.propTypes = {
  email: string,
  name: string,
  phoneNumber: string,
  rootElementId: string
};

ListingAgentContactDrawer.defaultProps = {
  email: "",
  name: "",
  phoneNumber: "",
  rootElementId: STREETEASY_SITE_CONTENT_SELECTOR
};

export default ListingAgentContactDrawer;
